import { useQuery } from '@apollo/client';
import isNumber from 'lodash/isNumber';

import { Query } from 'common/graphqlTypes';
import { DataRow } from 'plugins/types';

import { GET_CONSOLE_ENDPOINT_DATA } from './queries';

export const useConsoleEndpointData = ({
  pollInterval,
  values,
}: {
  pollInterval?: number;
  values: DataRow;
}): Partial<Query> | undefined => {
  const agentUUID = values['agent.uuid'];

  // TODO: When there is no agentUUID, we should throw
  // Currently, we are skipping the query since it will throw an error:
  // `"Variable 'agentUUID' has coerced Null value for NonNull type 'String!'"`
  // and because of the pollInterval, it will constantly will re-run the query
  // getting the same error
  const { data } = useQuery<Query>(GET_CONSOLE_ENDPOINT_DATA, {
    ...(isNumber(pollInterval) ? { pollInterval } : {}),
    variables: {
      console: `https://${values['mgmt.url']}`,
      agentUUID,
    },
    skip: !agentUUID,
  });

  return data;
};
